import {
  Color,
  Family,
  Paddings,
  toRem,
  setAlpha,
  Regular,
  Bold,
  FontFamilies,
  FontSizes,
  spacings,
  queries,
} from "./default";

export const fontFace = {
  fontFamily: Family,
  fontWeight: Regular,
};

export const html = {
  overflowX: "hidden",
  overflow: "hidden",
  [queries.print]: {
    background: "#FFF",
    backgroundColor: "#FFF",
    color: "black",
  },
};

export const body = (backgroundColor: string) => ({
  margin: 0,
  padding: 0,
  fontFamily: Family,
  backgroundColor,
  color: Color.onPrimary,
  overflowX: "hidden",
  overflow: "hidden",
  width: "100%",
  height: "100%",
  [queries.print]: {
    overflow: "hidden",
  },
});

export const button = {
  margin: 0,
  padding: 0,
  background: "none",
  cursor: "pointer",
  border: 0,
  color: Color.onBackground,
  display: "flex",
  alignItems: "center",
  gridGap: spacings.space2,
  ":hover": {
    color: Color.secondary,
  },
};

export const h1 = {
  fontFamily: FontFamilies.heading,
  fontSize: FontSizes.fontSize12,
  fontWeight: 900,
  lineHeight: "76px",
  letterSpacing: "-2px",
};

export const h2 = {
  fontFamily: FontFamilies.default,
  fontSize: FontSizes.fontSize5,
  fontWeight: "bold",
  letterSpacing: "-1px",
};

export const a = {
  fontFamily: Family,
  margin: 0,
  padding: 0,
  background: "none",
  cursor: "pointer",
  color: Color.onBackground,
  textDecoration: "underline",
  fontWeight: Bold,
  border: 0,
  ":hover": {
    color: Color.secondary,
  },
};

export const input = {
  backgroundColor: setAlpha(Color.primary400, 0.3),
  color: Color.onPrimary400,
  fontSize: toRem(18),
  border: `1px solid ${setAlpha(Color.onBackground, 0.2)}`,
  margin: 0,
  outline: 0,
  height: "32px",
  borderRadius: "3px",
  ":focus": {
    border: `1px solid ${Color.secondary}`,
  },
};

export const inputSearch = {
  // backgroundColor: setAlpha(Color.primary400, 0.3),
  // color: Color.onPrimary400,
  // fontSize: toRem(18),
  // border: `1px solid ${setAlpha(Color.onBackground, 0.2)}`,
  // margin: 0,
  // outline: 0,
  // height: "32px",
  // borderRadius: "3px",
  // ":focus": {
  //   border: `1px solid ${Color.secondary}`,
  // },

  backgroundColor: "#3A3B3C",
  border: 0,
  display: "flex",
  alignItems: "center",
  paddingBottom: spacings.space2,
  paddingRight: spacings.space4,
  paddingLeft: spacings.space8,
  paddingTop: spacings.space1,
  fontSize: FontSizes.fontSize3,
  height: "40px",
  ":focus": {
    border: 0,
  },
};

export const radio = {
  backgroundColor: Color.primary,
  color: Color.onPrimary,
  fontSize: toRem(14),
  border: `1px solid ${Color.primary200}`,
  margin: 0,
  outline: 0,
  padding: Paddings.default,
};

export const textarea = {
  backgroundColor: setAlpha(Color.primary400, 0.3),
  color: Color.onPrimary,
  fontSize: toRem(12),
  border: `1px solid ${setAlpha(Color.onBackground, 0.2)}`,
  margin: 0,
  outline: 0,
  padding: Paddings.slim,
  borderRadius: "3px",
  ":focus": {
    border: `1px solid ${Color.secondary}`,
  },
};
